import { createBrowserHistory, LocationDescriptorObject } from 'history';
import { RouterStore, syncHistoryWithStore, SynchronizedHistory } from 'mobx-react-router';

import { isBrowser } from '@vtblife/layout-components/utils/is-browser';

import { isGatsbyRoute } from '../utils';

export interface SynchronizedHistoryInstance {
    store: RouterStore;
    history: SynchronizedHistory;
}

let instance: SynchronizedHistoryInstance;

export const synchronizeHistory = (
    history = createBrowserHistory(),
    gatsbyRoutes: HtmlManifest,
): SynchronizedHistoryInstance => {
    if (isBrowser() && instance) {
        return instance;
    }

    const routerStore = new RouterStore();
    const synchronizedHistory = syncHistoryWithStore(history, routerStore);
    const onlyForGatsbyRoutes = (
        method: typeof synchronizedHistory.push,
        routes: string[],
    ): typeof synchronizedHistory.push => {
        return function (
            this: SynchronizedHistory,
            pathOrLocationDescriptor: string | LocationDescriptorObject,
            ...rest: any[]
        ) {
            const path =
                typeof pathOrLocationDescriptor === 'string'
                    ? pathOrLocationDescriptor
                    : pathOrLocationDescriptor.pathname || '';

            if (isGatsbyRoute(routes, path)) {
                window.location.href = path;
            } else {
                method.call(this, pathOrLocationDescriptor, ...rest);
            }
        };
    };
    synchronizedHistory.push = onlyForGatsbyRoutes(
        synchronizedHistory.push,
        gatsbyRoutes.map(({ route }) => route),
    );
    synchronizedHistory.replace = onlyForGatsbyRoutes(
        synchronizedHistory.replace,
        gatsbyRoutes.map(({ route }) => route),
    );

    instance = {
        store: routerStore,
        history: synchronizedHistory,
    };

    return instance;
};
